/**
 * Builds react-admin list URL with filter + displayedFilters query params.
 */
export const buildListFilterUrl = (path, filter, displayedFilterSources = []) => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const params = new URLSearchParams();

    if (filter && Object.keys(filter).length > 0) {
        params.set('filter', JSON.stringify(filter));
    }

    if (displayedFilterSources.length > 0) {
        const displayedFilters = displayedFilterSources.reduce((acc, source) => {
            acc[source] = true;
            return acc;
        }, {});
        params.set('displayedFilters', JSON.stringify(displayedFilters));
    }

    const query = params.toString();
    return query ? `${normalizedPath}?${query}` : normalizedPath;
};
